// import {combineReducers} from "redux";
import journalists from './journalistsReducer';

// if there are more than one reducer in this component, use combineReducers
/*
const journalists = combineReducers({
    journalists
})
*/

export default journalists;
